<template>
  <div>
    <van-tabbar v-model="active">
      <van-tabbar-item v-for="(item, index) in listInfo" :key="index" @click.native="changeActive(item.type, item.serviceId)">
        <div class='text_wrap'>
          <p class='text textOver'>{{ item.serviceName }}</p>
          <i class='active_icon' v-if="active === item.serviceId"></i>
          <i class='hidden_icon' v-else></i>
        </div>
        <template slot="icon" slot-scope="props">
          <p class='icon_wrap'>
            <img :src="item.picUrl" alt="">
          </p>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return{
      listInfo: [],
      active: 0,
    };
  },
  props: {
    serviceId: {
      type: Number,
    },
    outActive: Number,
  },
  methods: {
    changeActive(typeId, serviceId) {
      this.active = serviceId;
      this.$emit('changeActive', typeId, serviceId);
    },
    getList() {
      this.$http.post(`${this.URL_PREFIX}/app/get/park/service/list`, {
        parkId: this.currentParkId,
        parentId: this.serviceId,
      }).then((res) => {
        if (res.data.resCode === '10000') {
          this.listInfo = res.data.resData.pageList ? res.data.resData.pageList : [];
          // this.$emit('initActive', this.listInfo[0].type, this.listInfo[0].serviceId);
          let path = this.$route.path.split('/')[3] ? this.$route.path.split('/')[3] : false ;
          const id = this.$route.path.split('/')[3] && this.$route.path.split('/')[4] ? this.$route.path.split('/')[4] : this.listInfo[0].serviceId;
          this.active = Number(id);
          switch (path) {
            case 'recommend':
              this.$emit('changeActive', 11, id);
              break;
            case 'meetingRoom':
              this.$emit('changeActive', 12, id);
              break;
            case 'equipment':
              this.$emit('changeActive', 16, id);
              break;
            default:
              this.$emit('changeActive', this.listInfo[0].type, this.listInfo[0].serviceId);
              break;
          }
        }
      });
    },
  },
  computed: {
    ...mapGetters(['currentParkId']),
  },
  created() {
    this.getList();
  },
}
</script>


<style lang="scss" scoped>
@import '~@scss';

.van-tabbar{
  position: relative;
  height: 2.986667rem;
  padding-top: px2rem(40);
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: hidden;
  .van-tabbar-item{
    flex: 0;
    margin-left: px2rem(54);
    &:first-child{
      margin-left: px2rem(44);
    }

    .van-tabbar-item__icon{
      width: px2rem(100);
      height: px2rem(100);
      .icon_wrap{
        width: px2rem(100);
        height: px2rem(100);
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #EBEBEB;
        border-radius: 50%;
        img{
          width: px2rem(100);
          height: px2rem(100);
          border-radius: 50%;
        }
      }
    }
    .van-tabbar-item__text .text_wrap{
      text-align: center;
      .text{
        line-height: .88rem;
        font-size: .32rem;
        color: rgb(51, 51, 51);
        font-weight: 600;
      }
      .active_icon{
        display: inline-block;
        border-bottom: .266667rem solid rgb(245, 245, 245);
        border-left: .266667rem solid transparent;
        border-right: .266667rem solid transparent;
      }
      .hidden_icon{
        display: inline-block;
        height: .266667rem;
      }
    }
  }
}
.van-hairline--top-bottom::after {
    border-width: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/business/components/Tabbar.vue